import { filter } from "rxjs/operators";
export function equals(predicate) {
    return (source) => source.pipe(filter((value) => predicate === value));
}
//# sourceMappingURL=equals.js.map